






























































import Vue from "vue";
import Component from "vue-class-component";
import alert from "@/components/misc/alert.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "login",
    components: { alert },
})
export default class Login extends Vue {
    loginButtonLoading: boolean = false;
}
